import React from "react";
import {Button} from '@chakra-ui/react';

function Square({val, chooseSquare}){
  return(
    <>
      <Button onClick={chooseSquare} className="square" colorScheme="teal">
      {val}
      </Button>
    </>
  )
};

export default Square;